import api from '@/axios'

export default {
  findAll () {
    return api().get('system-wallet')
  },
  findOne (id) {
    return api().get(`system-wallet/${id}`)
  }
}
